import { h } from './p-85cb8c7d.js';
import { b as bem } from './p-a05fe53c.js';

const generateClassNames = bem('cosmos-live-icon-animated');
const CosmosLiveIconAnimated = ({ class: classname, slot, }) => {
    return (h("div", { class: [generateClassNames(), classname].join(' '), slot: slot },
        h("div", { class: generateClassNames('dot') })));
};

export { CosmosLiveIconAnimated as C };
